var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7192 2.42462C21.5929 1.95557 21.3457 1.52792 21.0022 1.18445C20.6587 0.840977 20.2311 0.593744 19.762 0.467492C18.0347 1.41685e-07 11.0936 0 11.0936 0C11.0936 0 4.15256 1.41685e-07 2.42522 0.467492C1.95617 0.593744 1.52851 0.840977 1.18504 1.18445C0.841573 1.52792 0.59434 1.95557 0.468088 2.42462C0.145555 4.18625 -0.0109619 5.97425 0.000596199 7.76512C-0.0109619 9.55599 0.145555 11.344 0.468088 13.1056C0.59434 13.5747 0.841573 14.0023 1.18504 14.3458C1.52851 14.6893 1.95617 14.9365 2.42522 15.0627C4.15256 15.5302 11.0936 15.5302 11.0936 15.5302C11.0936 15.5302 18.0347 15.5302 19.762 15.0627C20.2311 14.9365 20.6587 14.6893 21.0022 14.3458C21.3457 14.0023 21.5929 13.5747 21.7192 13.1056C22.0417 11.344 22.1982 9.55599 22.1867 7.76512C22.1982 5.97425 22.0417 4.18625 21.7192 2.42462ZM8.87502 11.093V4.43721L14.6355 7.76512L8.87502 11.093Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYt);
export default __webpack_public_path__ + "static/media/YT.82c1888dd71504cda02287650908ff67.svg";
export { ForwardRef as ReactComponent };